import { getGridTemplateColumns } from '../getGridTemplateColumns/getGridTemplateColumns';

type GetVisibleColumnsProps<T extends string> = {
  /** All possible columns and their order (e.g. `MY_TABLE_COLUMN`) */
  columnEnum: Record<string, T>;
  /** Visibility flag per column key */
  showColumnsConfig: Record<T, boolean>;
  /** CSS track size per column key (e.g. `'1fr'`, `'auto'`) */
  columnWidths: Record<T, string>;
};

type GetVisibleColumnsResult<T extends string> = {
  /** Ordered array of column keys that should be rendered, derived from `showColumnsConfig` */
  visibleColumns: T[];
  /** Space-joined CSS value ready for `grid-template-columns` inline style */
  gridTemplateColumns: string;
};

/**
 * Derives visible columns and `grid-template-columns` from a column visibility config.
 * See TABLE_GRID_DYNAMIC_COLUMNS.md — Approach 2.
 */
export const getVisibleColumns = <T extends string>({
  columnEnum,
  showColumnsConfig,
  columnWidths,
}: GetVisibleColumnsProps<T>): GetVisibleColumnsResult<T> => {
  const visibleColumns = Object.values(columnEnum).filter(
    (col) => showColumnsConfig[col as T],
  );

  const gridTemplateColumns = getGridTemplateColumns(visibleColumns, columnWidths);

  return {
    visibleColumns,
    gridTemplateColumns,
  };
};
